@if ((icon || sparksAnimation) && showIcon) {
  <div class="icon">
    <ng-content select="rt-icon, rt-sparks-animation" />
  </div>
}

<div class="text-content" min-width-0>
  <ng-content />
</div>

@if (iconHelp) {
  <div class="icon-help">
    <ng-content select="rt-icon-help" />
  </div>
}

@if (badge) {
  <div class="badge">
    <ng-content select="rt-badge" />
  </div>
}
